module.exports = "uniform vec3 color;\nuniform float opacity;\nuniform sampler2D texture;\nvoid main() {\n\tvec4 texColor = texture2D( texture, gl_PointCoord );\n\tgl_FragColor = texColor * vec4( color, opacity );\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shader/snow.frag
// module id = 4
// module chunks = 0